import { TradeTable } from "./FxTradeTable";

// 거래 분석 섹션 컴포넌트
export const TradeAnalysis = ({ type, period, data, userType }) => {
    const isAdmin = userType === 1020 || userType === 1021;
    const isBusiness = userType === 1024;
    
    // 데이터 매핑 함수
    const mapTradeData = (data) => {
        const summary = [];
        const air = [];
        const steam = [];
        const volumeByPeriod = [];
        const amountByPeriod = [];

        // current 데이터로 summary 생성
        data.current?.forEach(item => {
            summary.push({
                "구분": item.engName,
                "실거래량": `${item.trnsVol} ${item.trnsVolUnit}`,
                "거래금액": `${item.trnsVolChrg} ${item.trnsVolChrgUnit}`,
                "단가": item.unitPrice ? `${item.unitPrice}${item.unitPriceUnit}` : `0 ${item.unitPriceUnit}`
            });
        });

        // detailHistory 데이터로 압축공기 상세내역 생성
        data.detailHistory1?.forEach(item => {
            if (item.engId === "AIR") {
                air.push({
                    "사업장명": item.inloName,
                    "실거래량": `${item.trnsVol} ${item.trnsVolUnit}`,
                    "거래금액": `${item.trnsVolChrg} ${item.trnsVolChrgUnit}`,
                    "단가": item.unitPrice ? `${item.unitPrice}${item.unitPriceUnit}` : `0 ${item.unitPriceUnit}`
                });
            }
            if (item.engId === "STEAM") {
              steam.push({
                  "사업장명": item.inloName,
                  "실거래량": `${item.trnsVol} ${item.trnsVolUnit}`,
                  "거래금액": `${item.trnsVolChrg} ${item.trnsVolChrgUnit}`,
                  "단가": item.unitPrice ? `${item.unitPrice}${item.unitPriceUnit}` : `0 ${item.unitPriceUnit}`
              });
          }
        });

        // detailHistory2 데이터로 스팀 상세내역 생성
        data.detailHistory2?.forEach(item => {
          
            if (item.engId === "STEAM") {
                steam.push({
                    "사업장명": item.inloName,
                    "실거래량": `${item.trnsVol} ${item.trnsVolUnit}`,
                    "거래금액": `${item.trnsVolChrg} ${item.trnsVolChrgUnit}`,
                    "단가": item.unitPrice ? `${item.unitPrice}${item.unitPriceUnit}` : `0 ${item.unitPriceUnit}`
                    });
                }
            if (item.engId === "AIR") {
                  air.push({
                      "사업장명": item.inloName,
                      "실거래량": `${item.trnsVol} ${item.trnsVolUnit}`,
                      "거래금액": `${item.trnsVolChrg} ${item.trnsVolChrgUnit}`,
                      "단가": item.unitPrice ? `${item.unitPrice}${item.unitPriceUnit}` : `0 ${item.unitPriceUnit}`
                  });
              }     
        });

        // 월별 거래량 및 거래금액 생성
        
         data.detailHistory3?.forEach(item => {

          let obj= {};
          let psDate = item.psDate;
          if(volumeByPeriod.find((item) => item.날짜 === psDate))
          {
              obj=volumeByPeriod.find((item) => item.날짜 === psDate);    
              if(item.engId == "AIR"){
                obj["압공 거래량"] = item.tradeVol + " " + item.tradeVolUnit;
              }
              if(item.engId == "STEAM"){
                obj["스팀 거래량"] = item.tradeVol + " " + item.tradeVolUnit;            
              }       
            
          }else{
            obj["날짜"] = psDate;
            
            
            if(item.engId == "AIR"){
              obj["압공 거래량"] = item.tradeVol + " " + item.tradeVolUnit;
            }
            if(item.engId == "STEAM"){
              obj["스팀 거래량"] = item.tradeVol + " " + item.tradeVolUnit;            
            }

            volumeByPeriod.push(obj);
          }

          let obj2= {};
          
          if(amountByPeriod.find((item) => item.날짜 === psDate))
          {
              obj2=amountByPeriod.find((item) => item.날짜 === psDate);    
              if(item.engId == "AIR"){
                obj2["압공 거래금액"] = item.tradeAmt + " " + item.tradeAmtUnit;
              }
              if(item.engId == "STEAM"){
                obj2["스팀 거래금액"] = item.tradeAmt + " " + item.tradeAmtUnit;            
              }       
            
          }else{
            obj2["날짜"] = psDate;
            
            
            if(item.engId == "AIR"){
              obj2["압공 거래금액"] = item.tradeAmt + " " + item.tradeAmtUnit;
            }
            if(item.engId == "STEAM"){
              obj2["스팀 거래금액"] = item.tradeAmt + " " + item.tradeAmtUnit;            
            }

            amountByPeriod.push(obj2);
          }
        });

         // 연간 거래량 및 거래금액 생성
         data.detailHistory4?.forEach(item => {
          let obj= {};
          let month = item.mm;
          if(volumeByPeriod.find((item) => item.날짜 === month))
          {
              obj=volumeByPeriod.find((item) => item.날짜 === month);    
              if(item.engId == "AIR"){
                obj["압공 거래량"] = item.trnsVol + " " + item.engUnit;
              }
              if(item.engId == "STEAM"){
                obj["스팀 거래량"] = item.trnsVol + " " + item.engUnit;            
              }       
            
          }else{
            obj["날짜"] = month;
            
            
            if(item.engId == "AIR"){
              obj["압공 거래량"] = item.trnsVol + " " + item.engUnit;
            }
            if(item.engId == "STEAM"){
              obj["스팀 거래량"] = item.trnsVol + " " + item.engUnit;            
            }

            volumeByPeriod.push(obj);
          }
          

          let obj2= {};
          
          if(amountByPeriod.find((item) => item.날짜 === month))
          {
              obj2=amountByPeriod.find((item) => item.날짜 === month);    
              if(item.engId == "AIR"){
                obj2["압공 거래금액"] = item.calcAmt + " " + item.engPriceUnit;
              }
              if(item.engId == "STEAM"){
                obj2["스팀 거래금액"] = item.calcAmt + " " + item.engPriceUnit;            
              }       
            
          }else{
            obj2["날짜"] = month;
            
            
            if(item.engId == "AIR"){
              obj2["압공 거래금액"] = item.calcAmt + " " + item.engPriceUnit;
            }
            if(item.engId == "STEAM"){
              obj2["스팀 거래금액"] = item.calcAmt + " " + item.engPriceUnit;            
            }

            amountByPeriod.push(obj2);
          }

         });

        return {
            summary,
            air,
            steam,
            volumeByPeriod,
            amountByPeriod
        };
    };

    const mappedData = mapTradeData(data);

    return (
      <dl>
        <dt>{type === 'SINK' ? '매수거래 분석' : '매도거래 분석'}</dt>
        <dd>
          <strong>
            {period === "MONTH" ? "1. 당월 거래량 및 거래금액" : "1. 연간 거래량 및 거래금액"}
          </strong>
          <TradeTable 
            columns={["구분", "실거래량", "거래금액", "단가"]}
            data={mappedData.summary}
          />
          
          <strong>
            {isAdmin ? "2. 사업장별 세부 거래내역" : "2. 세부 거래내역"}
          </strong>
          
          {isAdmin && (
            <>
              <b>* 압축공기</b>
              <TradeTable 
                columns={["사업장명", "실거래량", "거래금액", "단가"]}
                data={mappedData.air}
              />
              <b>* 스팀</b>
              <TradeTable 
                columns={["사업장명", "실거래량", "거래금액", "단가"]}
                data={mappedData.steam}
              />
            </>
          )}
          
          {isBusiness && (
            <>
              <b>* {period === "MONTH" ? "일별" : "월별"} 거래량</b>
              <TradeTable 
                columns={["날짜", "압공 거래량", "스팀 거래량"]}
                data={mappedData.volumeByPeriod}
              />
              <b>* {period === "MONTH" ? "일별" : "월별"} 거래금액</b>
              <TradeTable 
                columns={["날짜", "압공 거래금액", "스팀 거래금액"]}
                data={mappedData.amountByPeriod}
              />
            </>
          )}
        </dd>
      </dl>
    );
  };